import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-0"}],["path",{"d":"M2.5 17a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-1"}],["path",{"d":"M13.5 17a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-2"}]]

const IconCircles = createReactComponent('outline', 'circles', 'Circles', __iconNode);

export default IconCircles;